export default __webpack_public_path__ + "static/media/480_business04-jp-mobile.46e85165.png";